export default __webpack_public_path__ + "static/media/lilia.9de74e07.jpeg";